const getters = {
    smartAgentFirstStepCat: state => {
        return state.smartAgent.firstStepCategory.cat.NameInHebrew
    }
}

export default getters